import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './CookieConsent.css';

const CookieConsent = () => {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const consent = localStorage.getItem('vkr-cookie-consent-accepted');
        if (!consent) {
            // Показываем баннер с небольшой задержкой для плавности
            const timer = setTimeout(() => {
                setIsVisible(true);
            }, 1000);
            return () => clearTimeout(timer);
        }
    }, []);

    const handleAccept = () => {
        localStorage.setItem('vkr-cookie-consent-accepted', 'true');
        setIsVisible(false);
    };

    if (!isVisible) return null;

    return (
        <div className="cookie-consent-banner">
            <div className="cookie-consent-content">
                <div className="cookie-consent-text">
                    Этот сайт использует файлы cookie и другие метаданные для обеспечения безопасности сессий, защиты от CSRF и корректного подбора вакансий в командах. 
                    Продолжая использовать сайт, вы соглашаетесь с нашей{' '}
                    <Link to="/privacy-policy" className="cookie-policy-link">Политикой конфиденциальности</Link> в соответствии с ФЗ-152.
                </div>
                <button className="cookie-consent-btn" onClick={handleAccept}>
                    Принять
                </button>
            </div>
        </div>
    );
};

export default CookieConsent;
